import React, { useState, useEffect, useContext } from 'react'
import { Link, useLocation } from 'react-router-dom'
import logo from '../../../assets/img/logo.png'
import menuimg from '../../../assets/img/common/menuimg.png'
import logoWhite from '../../../assets/img/logo.png'
import specialoffer from '../../../assets/img/custom/special-offer.png'
import avater from '../../../assets/img/common/avater.png'
import TopHeader from './TopHeader'
import { useHistory } from "react-router-dom"
import svg from '../../../assets/img/svg/cancel.svg'
import svgsearch from '../../../assets/img/svg/search.svg'
import { withRouter } from 'react-router-dom';
import { IoCartOutline, IoPersonOutline, IoSearch, IoLogoFacebook, IoLogoTwitter, IoLogoLinkedin, IoLogoYoutube, IoLogoInstagram } from "react-icons/io5";
import { useDispatch, useSelector } from "react-redux";
import Swal from 'sweetalert2'
import { connect } from "react-redux";
import { AuthContext } from '../../../context/AuthContext'
import * as branche from "../../../actions/branche";
import * as department from "../../../actions/department";
import * as user from "../../../actions/user";
import * as actions from "../../../actions/service";
import * as category from "../../../actions/category";
import { useTranslation } from 'react-i18next';
import _ from 'lodash'
import { compose } from 'redux'
import Cookies from 'js-cookie'
import Button from 'react-bootstrap/Button';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Dropdown from 'react-bootstrap/Dropdown';
import BookingModal from '../../../page/bookingModal'

const Header = (props) => {
    const { t, i18n } = useTranslation();
    let location = useLocation();
    const { logout, getAuthUser, isAuthenticated, getCurrentBranch } = useContext(AuthContext)
    const authUser = getAuthUser()
    const branch = getCurrentBranch()
    const [myCart, setMycart] = useState(props.cartArray);
    const [currentLang, setCurrentLang] = useState(Cookies.get('fj_lang') || 'en');
    const [keyword, setKeyword] = useState("");

    const [stylePath, setStylePath] = useState(Cookies.get('fj_lang') === 'ar' ? "/assets/css/bootstrap.rtl.min.css" : "/assets/css/bootstrap.min.css");

    const [click, setClick] = useState(false);
    const [showTreatMenu, setShowTreatMenu] = useState(false);
    const [show, setShow] = useState();
    const history = useHistory()
    let carts = useSelector((state) => state?.products?.carts);
    let favorites = useSelector((state) => state?.products?.favorites);
    let dispatch = useDispatch();
    const [treatments, setTreatments] = useState([]);

    useEffect(() => {
        const onSuccess = (res) => {

        }
        props.fetchBranches();
        props.fetchDepartments();

        //  props.fetchServices();
        props.fetchCategories();
        props.fetchServices({ type: 'product', status: 'active' }, onSuccess);

    }, []);



    const rmCartProduct = (id) => {
        dispatch({ type: "products/removeCart", payload: { id } });
    }

    const rmFavProduct = (id) => {
        dispatch({ type: "products/removeFav", payload: { id } });
    }

    const cartTotal = () => {
        return carts?.reduce(function (total, item) {
            return total + ((item.quantity || 1) * item.price)
        }, 0)
    }

    const handleClick = () => {
        if (click) {
            document.querySelector("#offcanvas-add-cart").style = ("transform: translateX(100%);")
        } else {
            document.querySelector("#offcanvas-add-cart").style = ("transform: translateX(0%);")
        }
        setClick(!click);
    }
    const handleWish = () => {
        if (click) {
            document.querySelector("#offcanvas-wishlish").style = ("transform: translateX(100%);")
        } else {
            document.querySelector("#offcanvas-wishlish").style = ("transform: translateX(0);")
        }
        setClick(!click);
    }

    const handleSearch = () => {
        if (click) {
            document.querySelector("#search").style = ("transform: translate(-100%, 0); opacity: 0")
        } else {
            document.querySelector("#search").style = ("transform: translate(0px, 0px); opacity: 1")
        }
        setClick(!click);
    }
    const handleabout = () => {
        if (click) {
            document.querySelector("#offcanvas-about").style = ("transform: translateX(100%);")
        } else {
            document.querySelector("#offcanvas-about").style = ("transform: translateX(0%);")
        }
        setClick(!click);
    }
    const handlemenu = () => {
        if (click) {
            document.querySelector("#mobile-menu-offcanvas").style = ("transform: translateX(100%);")
        } else {
            document.querySelector("#mobile-menu-offcanvas").style = ("transform: translateX(0%);")
        }
        setClick(!click);
    }

    const handleShow = (value) => {
        value === show ? setShow("") : setShow(value)
    }

    // Sticky Menu Area
    useEffect(() => {
        window.addEventListener('scroll', isSticky);
        return () => {
            window.removeEventListener('scroll', isSticky);
        };
    });

    const isSticky = (e) => {
        const header = document.querySelector('.header-section');
        const scrollTop = window.scrollY;
        scrollTop >= 250 ? header.classList.add('is-sticky') : header.classList.remove('is-sticky');
    };

    const changeLanguage = (event) => {
        let lang = event.target.value;
        let newUrl
        if (lang === 'en') {
            setStylePath("/assets/css/bootstrap.min.css")
            newUrl = location.pathname.replace('/ar', `/${lang}`)
        } else {
            setStylePath("/assets/css/bootstrap.rtl.min.css")
            newUrl = location.pathname.replace('/en', `/${lang}`)
        }
        setCurrentLang(lang)
        Cookies.set('fj_lang', lang)
        i18n.changeLanguage(lang);
        window.location.replace(newUrl);
        // window.location.reload(false);
    };
    useEffect(() => {
        var head = document.head;
        var link = document.createElement("link");

        link.type = "text/css";
        link.rel = "stylesheet";
        link.href = stylePath;

        head.prepend(link);
        document.getElementById("deafult-bs4").disabled = true;

        return () => { head.removeChild(link); }

    }, [stylePath]);

    const signout = () => {
        logout(history)
        // Swal.fire({
        //     icon: 'success',
        //     title: 'Logout Sucessfull',
        //     text: 'Thank You'
        // })
        // dispatch({ type: "user/logout" })
        // history.push("/");
    }

    const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
        <a
            href=""
            ref={ref}
            onClick={(e) => {
                e.preventDefault();
                onClick(e);
            }}
        >
            {children}

        </a>
    ));
    return (
        <>
            <TopHeader authUser={authUser} logout={logout} {...props} />
            <header className="header-section d-none d-xl-block shadow-sm">
                <div className="header-wrapper">
                    <div className="header-bottom header-bottom-color--golden section-fluid sticky-header sticky-color--golden">
                        <div className="container">
                            <div className="row d-none">
                                <div className="col-12 d-flex align-items-lg-end justify-content-between">
                                    <div className="header-logo">
                                        <div className="logo">
                                            <Link to="/"><img src={logo} alt="logo" /></Link>

                                        </div>
                                    </div>
                                    <div className="main-menu menu-color--black menu-hover-color--golden d-none d-xl-block">

                                        <div className="input-group">
                                            <input value={keyword} onChange={e => {
                                                setKeyword(e.target.value)
                                                props.searchTreatments(e.target.value)
                                            }} className={`form-control border  border-right-0 ${currentLang === 'ar' ? "rounded-pill-right" : "rounded-pill-left"}`} type="search" placeholder={t('searchplaceholder')} />
                                            <span className="input-group-append">
                                                <button className={`btn btn-outline-secondary border  ${currentLang === 'ar' ? "rounded-pill-left border-right-0" : "rounded-pill-right border-left-0"}`} type="button">
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </span>
                                        </div>
                                        {props.searched.length > 0 && keyword.length > 0 && <div className="searchedResultBox shadow">
                                            {props.searched.map((item, i) =>
                                                <Link key={i} to={{
                                                    pathname: `/treatments/${(item.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                                                        service: item,
                                                        cartArray: myCart,
                                                        count: _.countBy(myCart)[item.id]
                                                    }

                                                }} onClick={() => setKeyword("")}>
                                                    <div className="row mb-4 border-bottom pb-4" >
                                                        <div className='col-2'>
                                                            <img className='searchedimg' src={process.env.REACT_APP_IMG_URL + item.image} />
                                                        </div>
                                                        <div className='col-10'>

                                                            <h4 >{item.title[i18n.language]}</h4>
                                                            <p className='font-weight-light lines p-0 mb-1'>{item.description[i18n.language]?.replace(/<[^>]+>|&nbsp;|&amp;/g, '')}</p>

                                                        </div>
                                                    </div>
                                                </Link>
                                            )}
                                        </div>}


                                    </div>

                                    <ul className="header-action-link action-color--black action-hover-color--golden">
                                        {/* <li>
                                            {favorites?.length
                                                ? <a href="#offcanvas-wishlish" className="offcanvas-toggle" onClick={handleWish}><i className="fa fa-heart"></i><span className="item-count">{favorites.length}</span></a>
                                                : <a href="#offcanvas-wishlish" className="offcanvas-toggle"><i className="fa fa-heart"></i><span className="item-count">{favorites?.length}</span></a>
                                            }
                                        </li> */}
                                        <li>
                                            <select className="lang-center-input" onChange={changeLanguage} value={currentLang}>
                                                <option value="en">{t('english')}</option>
                                                <option value="ar">{t('arabic')}</option>

                                            </select>

                                        </li>
                                        {/* <li>
                                            {global.cartBadge > 0

                                                ? <Link to="/cartThree" ><i className="fa fa-shopping-bag"></i><span className="item-count">{global.cartBadge}</span></Link>
                                                : <a className="offcanvas-toggle"><i className="fa fa-shopping-bag"></i></a>
                                            }
                                        </li> */}


                                        {/* {authUser && <li>
                                            <Dropdown >
                                                <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
                                                    <a className="search_width pl-0"  >
                                                        <IoPersonOutline />
                                                    </a>
                                                </Dropdown.Toggle>

                                                <Dropdown.Menu>
                                                    <Dropdown.Item><a><img style={{ height: '20px', width: '20px', borderRadius: 25 }} src={process.env.REACT_APP_IMG_URL + (authUser.avatar ? authUser.avatar : avater)} />  {authUser.firstName + ' ' + authUser.lastName}</a></Dropdown.Item>
                                                    <Dropdown.Divider />
                                                    <Dropdown.Item><Link to="/profile"><i className="fa fa-user"></i> &nbsp;{t('myprofile')}</Link></Dropdown.Item>
                                                    <Dropdown.Item><a onClick={() => { signout() }}><i className="fa fa-sign-out"></i> {t('signout')}</a></Dropdown.Item>
                                                </Dropdown.Menu>
                                            </Dropdown>
                                        </li>}
                                        {!authUser && <>
                                            <li><Link to="/login" className='unauth'><i className="fa fa-user"></i> {t('login')}</Link></li>
                                            <li className='mr-1'><Link to="/register" className='unauth'><i className="fa fa-lock"></i> {t('signup')}</Link></li>
                                        </>} */}


                                    </ul>
                                </div>
                            </div>
                            <div className="row">

                                <div className="col-12 d-flex justify-content-between">
                                    <div className="header-logo">
                                        <div className="logo">
                                            <Link to="/"><img src={logo} alt="logo" /></Link>

                                        </div>
                                    </div>
                                    <div className="main-menu menu-color--black menu-hover-color--golden d-none d-xl-block">
                                        <nav>
                                            <ul>
                                                <li className="has-dropdown">
                                                    <Link to="/" className={`main-menu-link ${location?.pathname === "/" ? "menuborder" : ""}`}>{t('home')}</Link>
                                                </li>
                                                <li className="has-dropdown has-megaitem">
                                                    <a className={`main-menu-link ${location?.pathname?.includes('/treatments/') ? "menuborder" : ""}`} onMouseEnter={() => setShowTreatMenu(true)}>{t('treatments')} <i className="fa fa-angle-down"></i></a>
                                                    <div className={showTreatMenu ? "mega-menu mega-menu-xl" : 'd-none'}>

                                                        {props.categories.map((item, i) =>
                                                            <div className='innerdivmega' key={i}>
                                                                <img className='my-2' src={process.env.REACT_APP_IMG_URL + item.image} style={{ width: 150, height: 100, objectFit: 'cover' }} />
                                                                <p className='text-eve mb-1 small text-uppercase'>{item.title?.en && item.title[i18n.language]}</p>
                                                                {props.servicesHeader.filter(e => e.categoryId.id === item.id && e.type === 'product').map((data, index) => (
                                                                    <Link to={{
                                                                        pathname: `/treatments/${(data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                                                                            service: data,
                                                                            cartArray: myCart,
                                                                            count: _.countBy(myCart)[data.id]
                                                                        }
                                                                    }} onClick={() => setShowTreatMenu(false)}>
                                                                        <a key={index} className='small d-block'>{data.title[i18n.language]}</a>
                                                                    </Link>
                                                                ))}
                                                            </div>
                                                        )}

                                                        {/* <div className='float-right' style={{


                                                            width: '30%'

                                                        }}>
                                                            <img src={menuimg} />
                                                        </div> */}

                                                        {/* <ul className="mega-menu-inner">
                                                        {props.categories.map((data, index) => (
                                                       <li key={index} className="mega-menu-item">
                                                                <p className="mega-menu-item-title text-eve">{data.title}</p>
                                                                <ul className="mega-menu-sub">
                                                                {props.services.filter(e=>e.categoryId===data.id && e.type==='product').map((data, index) => (<li key={index}><a href="/order-success">{data.title}</a></li>))}
                                                                  
                                                                </ul>
                                                            </li>
                                                        ))}
                                                          
                                                            <li className="mega-menu-item">
                                                                <div className="menu-banner"><a className="menu-banner-link" href="/shop">
                                                                    <img className="menu-banner-img" alt="img" /></a></div>
                                                            </li>
                                                        </ul> */}
                                                    </div>
                                                </li>
                                                {/* <li className="has-dropdown">
                                                    <a href="#!" className="main-menu-link">{t('departments')} <i className="fa fa-angle-down"></i></a>
                                                    <ul className="sub-menu">
                                                    {props.departments.map((data, index) => (<li key={index}><a href="/order-success">{data.title}</a></li>))}
                                                
                                                    </ul>
                                                </li> */}
                                                <li>
                                                    <Link to={{ pathname: `/departments` }} className={`main-menu-link ${location?.pathname === "/departments" ? "menuborder" : ""}`}>{t('departments')}</Link>

                                                </li>
                                                <li>
                                                    <Link to={{ pathname: `/doctors` }} className={`main-menu-link ${location?.pathname === "/doctors" ? "menuborder" : ""}`}>{t('doctors')}</Link>

                                                </li>
                                                <li>
                                                    <Link to={{ pathname: `/before-after` }} className={`main-menu-link ${location?.pathname === "/before-after" ? "menuborder" : ""}`}>{t('beforenafter')}</Link>

                                                </li>
                                                <li className="has-dropdown">
                                                    <Link to={{ pathname: `/estore`, state: { type: 'package' } }} className="main-menu-link">{t('offers')}</Link>

                                                </li>
                                                <li>
                                                    <Link to={{ pathname: `/blogs` }} className={`main-menu-link ${location?.pathname === "/blogs" ? "menuborder" : ""}`}>{t('blogs')}</Link>

                                                </li>
                                                <li>
                                                    <Link to={{ pathname: `/contacts` }} className={`main-menu-link ${location?.pathname === "/contacts" ? "menuborder" : ""}`}>{t('contactus')}</Link>

                                                </li>


                                                {/* <li className="has-dropdown">
                                                    <a href="#!" className="main-menu-link">{t('shop')} <i className="fa fa-angle-down"></i></a>
                                                    <ul className="sub-menu">
                                                        <li className="has-dropdown">
                                                            <Link to={{ pathname: `/estore`, state: { type: 'package' } }} className="main-menu-link">{t('packages')}</Link>

                                                        </li>
                                                        <li className="has-dropdown">
                                                            <Link to={{ pathname: `/estore`, state: { type: 'product' } }} className="main-menu-link">{t('treatments')}</Link>

                                                        </li>
                                                        
                                                        <li className="has-dropdown">
                                                <Link to={{pathname: `/estore`, state: { type: 'item' }}} className="main-menu-link">Products</Link>
                                                  
                                                </li> 
                                                        <li className="has-dropdown">
                                                            <Link to={{ pathname: `/estore`, state: { type: 'coupon' } }} className="main-menu-link">{t('coupons')}</Link>

                                                        </li>
                                                    </ul>
                                                </li> */}
                                                {/* <li>

                                                    <a href="#search" className="search_width" onClick={handleSearch} >
                                                        <IoSearch />
                                                    </a>
                                                </li> */}



                                                {/* {authUser && <li className="has-dropdown">
                                                    <Link to={{ pathname: `/appointments` }} className="main-menu-link"><i className="fa fa-calendar-plus-o"></i>  {t('appointments')}</Link>

                                                </li>}
                                                <li><Link to={{ pathname: `/estore`, state: { type: 'coupon' } }}><img src={specialoffer} style={{ height: '35px' }} /></Link></li> */}


                                            </ul>

                                        </nav>
                                    </div>

                                    <div className="header-action-link action-color--black action-hover-color--golden">
                                        <select className="lang-center-input" onChange={changeLanguage} value={currentLang}>
                                            <option value="en">{t('En')}</option>
                                            <option value="ar">{t('Ar')}</option>

                                        </select>
                                        <div className="input-group input-group-sm px-2">
                                            <input value={keyword} onChange={e => {
                                                setKeyword(e.target.value)
                                                props.searchTreatments(e.target.value)
                                            }} className={`form-control border  `} type="search" placeholder={t('searchplaceholder')} />
                                            <span className="input-group-append">
                                                <button className={`btn btn-outline-secondary border`} type="button">
                                                    <i className="fa fa-search"></i>
                                                </button>
                                            </span>
                                        </div>

                                        <BookingModal type="generic" />
                                        {/* <Link to={{ pathname: `/doctors` }} className="main-menu-link"><button className='btn btn-warning btn-sm'>{t('bookappt')}</button></Link> */}

                                    </div>

                                    {props.searched.length > 0 && keyword.length > 0 && <div className="searchedResultBox shadow">
                                        {props.searched.map((item, i) =>
                                            <Link key={i} to={{
                                                pathname: `/treatments/${(item.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                                                    service: item,
                                                    cartArray: myCart,
                                                    count: _.countBy(myCart)[item.id]
                                                }

                                            }} onClick={() => setKeyword("")}>
                                                <div className="row mb-4 border-bottom pb-4" >
                                                    <div className='col-2'>
                                                        <img className='searchedimg' src={process.env.REACT_APP_IMG_URL + item.image} />
                                                    </div>
                                                    <div className='col-10'>

                                                        <h4 >{item.title[i18n.language]}</h4>
                                                        <p className='font-weight-light lines p-0 mb-1'>{item.description[i18n.language]?.replace(/<[^>]+>|&nbsp;|&amp;/g, '')}</p>
                                                        {/* <span className="price">

                                                                {item.type === 'package' ?

                                                                    <span className="new">{`AED ${(item.enabledGlobalDiscount) ? item.price - Math.round((item.discount / 100) * item.price) : item.price}`} {item.discount != 0 && item.enabledGlobalDiscount && <del className='price-muted font-weight-normal'> {t('aed')} {item.price} </del>} </span>

                                                                    :

                                                                    <span className="new">{`AED ${(item.price - Math.round((item.discount / 100) * item.price))}`} {item.discount != 0 && <del className='price-muted font-weight-normal'> {t('aed')} {item.price} </del>} </span>

                                                                }


                                                            </span> */}
                                                        {/* {item.discount > 0 && <span className='discount badge cart-label font-weight-light ml-2'>{item.discount} % {t('discount')}</span>} */}
                                                    </div>
                                                </div>
                                            </Link>
                                        )}
                                    </div>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </header>

            <div className="mobile-header sticky-header sticky-color--golden mobile-header-bg-color--golden section-fluid d-lg-block d-xl-none">
                <div className="container">
                    <div className="row">
                        <div className="col-12 d-flex align-items-center justify-content-between">

                            <div className="mobile-header-left">
                                <ul className="mobile-menu-logo">
                                    <li>
                                        <Link to="/">
                                            <div className="logo">
                                                <img src={logo} alt="logo" />
                                            </div>
                                        </Link>
                                    </li>
                                </ul>
                            </div>

                            <div className="mobile-right-side">
                                <ul className="header-action-link action-color--black action-hover-color--golden">
                                    <li>
                                        <div className='ml-2'>

                                            <div className="input-group">
                                                <input value={keyword} onChange={e => {
                                                    setKeyword(e.target.value)
                                                    props.searchTreatments(e.target.value)
                                                }} className={`form-control border  border-right-0 ${currentLang === 'ar' ? "rounded-pill-right" : "rounded-pill-left"}`} type="search" placeholder={t('searchplaceholder')} />
                                                <span className="input-group-append">
                                                    <button className={`btn btn-outline-secondary border  ${currentLang === 'ar' ? "rounded-pill-left border-right-0" : "rounded-pill-right border-left-0"}`} type="button">
                                                        <i className="fa fa-search"></i>
                                                    </button>
                                                </span>
                                            </div>
                                            {props.searched.length > 0 && keyword.length > 0 && <div className="searchedResultBox shadow">
                                                {props.searched.map((item, i) =>
                                                    <Link key={i} to={{
                                                        pathname: `/treatments/${(item.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                                                            service: item,
                                                            cartArray: myCart,
                                                            count: _.countBy(myCart)[item.id]
                                                        }

                                                    }} onClick={() => setKeyword("")}>
                                                        <div className="row mb-4 border-bottom pb-4" >
                                                            <div className='col-4'>
                                                                <img className='searchedimg' src={process.env.REACT_APP_IMG_URL + item.image} />
                                                            </div>
                                                            <div className='col-8'>

                                                                <h4 >{item.title[i18n.language]}</h4>
                                                                <p className='font-weight-light lines p-0 mb-1'>{item.description[i18n.language]?.replace(/<[^>]+>|&nbsp;|&amp;/g, '')}</p>

                                                            </div>
                                                        </div>
                                                    </Link>
                                                )}
                                            </div>}


                                        </div>
                                    </li>
                                    {/* <li>
                                        <a href="#!" className="search_width" onClick={handleSearch}>
                                            <img src={svgsearch} alt="img" />
                                        </a>
                                    </li>

                                    <li>
                                        {global.cartBadge > 0

                                            ? <a href="/cartThree" className="offcanvas-toggle" onClick={handleClick}><i className="fa fa-shopping-bag"></i><span className="item-count">{global.cartBadge}</span></a>
                                            : <a className="offcanvas-toggle"><i className="fa fa-shopping-bag"></i></a>
                                        }
                                    </li> */}
                                    {/* {authUser && <li className="after_login px-0"><a className="search_width pl-0"  >
                                            <IoPersonOutline />
                                        </a>
                                            <ul className="custom_dropdown">
                                                <li className='font-weight-bold'><img src={authUser.avatar ? authUser.avatar : avater} alt="avater" />  {authUser.firstName + ' ' + authUser.lastName}</li>
                                                <hr />
                                                <li><span onClick={() => { signout() }}><i className="fa fa-sign-out"></i> Logout</span></li>
                                            </ul>
                                        </li>} */}
                                    {/* <li>
                                        {favorites?.length
                                            ? <a href="#offcanvas-wishlish" className="offcanvas-toggle" onClick={handleWish}><i className="fa fa-heart"></i><span className="item-count">{favorites.length}</span></a>
                                            : <a href="#offcanvas-wishlish" className="offcanvas-toggle"><i className="fa fa-heart"></i><span className="item-count">{favorites?.length}</span></a>
                                        }
                                    </li>
                                    <li>
                                        {carts?.length
                                            ? <a href="#!" className="offcanvas-toggle" onClick={handleClick}><i className="fa fa-shopping-bag"></i><span className="item-count">{carts.length}</span></a>
                                            : <a href="#!" className="offcanvas-toggle"><i className="fa fa-shopping-bag"></i><span className="item-count">{carts?.length}</span></a>
                                        }
                                    </li> */}
                                    <li>
                                        <a href="#!" className="offcanvas-toggle offside-menu" onClick={handlemenu}>
                                            <i className="fa fa-bars"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div id="mobile-menu-offcanvas" className="offcanvas offcanvas-rightside offcanvas-mobile-menu-section">

                <div className="offcanvas-header text-right">

                    <button className="offcanvas-close" onClick={handlemenu}>
                        <img src={svg} alt="icon" />
                    </button>
                </div>
                <div className="offcanvas-mobile-menu-wrapper">
                    <div className="mobile-menu-bottom">
                        <div className="offcanvas-menu">
                            <ul>
                                {/* <li>
                                    {authUser && <a className="after_login text-white px-0">
                                        <img style={{ height: '20px', width: '20px', borderRadius: 25 }} src={process.env.REACT_APP_IMG_URL + (authUser.avatar ? authUser.avatar : avater)} />  {authUser.firstName + ' ' + authUser.lastName}
                                    </a>}
                                </li> */}
                                {/* {!authUser && <>
                                    <li><Link to="/login" onClick={handlemenu} className='unauth'><i className="fa fa-user"></i> {t('login')}</Link></li>
                                    <li className='mr-1'><Link to="/register" onClick={handlemenu} className='unauth'><i className="fa fa-lock"></i> {t('signup')}</Link></li>
                                </>} */}
                                <li>

                                    <Link to="/" onClick={handlemenu} className='unauth'>{t('home')}</Link>
                                </li>

                                <li>
                                    <a href="#!" onClick={() => handleShow("Treatments")}><span>{t('treatments')} <i className="fa fa-angle-down"></i></span></a>
                                    {
                                        show === "Treatments" ?
                                            <ul className="mobile-sub-menu">
                                                {props?.categories.map((item, i) =>
                                                    <div className='mb-2' key={i}>
                                                        <p className='text-eve my-2'>{item?.title[i18n.language]}</p>

                                                        {props.servicesHeader.filter(e => e.categoryId.id === item.id && e.type === 'product').map((data, index) => (
                                                            <Link to={{
                                                                pathname: `/treatments/${(data.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                                                                    service: data,
                                                                    cartArray: myCart,
                                                                    count: _.countBy(myCart)[data.id]
                                                                }
                                                            }} onClick={handlemenu}>
                                                                <a key={index} className='font-weight-light d-block'>{data.title[i18n.language]}</a>
                                                            </Link>
                                                        ))}
                                                    </div>
                                                )}

                                            </ul> : null
                                    }

                                </li>
                                {/* <li className="has-dropdown">
                                                    <a href="#!" className="main-menu-link">{t('departments')} <i className="fa fa-angle-down"></i></a>
                                                    <ul className="sub-menu">
                                                    {props.departments.map((data, index) => (<li key={index}><a href="/order-success">{data.title}</a></li>))}
                                                
                                                    </ul>
                                                </li> */}
                                <li>
                                    <Link to={{ pathname: `/departments` }} onClick={handlemenu} className="main-menu-link">{t('departments')}</Link>

                                </li>
                                <li>
                                    <Link to={{ pathname: `/doctors` }} onClick={handlemenu} className="main-menu-link">{t('doctors')}</Link>

                                </li>

                                <li>
                                    <Link to={{ pathname: `/before-after` }} onClick={handlemenu} className="main-menu-link">{t('beforenafter')}</Link>

                                </li>
                                <li>
                                    <Link to={{ pathname: `/estore`, state: { type: 'package' } }} onClick={handlemenu} className="main-menu-link">{t('offers')}</Link>

                                </li>
                                <li>
                                    <Link to={{ pathname: `/blogs` }} onClick={handlemenu}  className="main-menu-link">{t('blogs')}</Link>

                                </li>
                                <li>
                                    <Link to={{ pathname: `/contacts` }} onClick={handlemenu} className="main-menu-link">{t('contacts')}</Link>

                                </li>
                                {/* <li>

                                    <a href='https://www.mentalhealth.aecmc.com' target='_blank' className="main-menu-link tpbtn">{t('childsite')}</a>

                                </li> */}
                                <li>
                                    <BookingModal type="generic" />

                                </li>

                                {/* <li>
                                    <a href="#!" onClick={() => handleShow("Shop")}><span>Shop <i className="fa fa-angle-down"></i></span></a>
                                    {
                                        show === "Shop" ?
                                            <ul className="mobile-sub-menu">
                                                <li>
                                                    <Link to={{ pathname: `/estore`, state: { type: 'package' } }} className="main-menu-link" onClick={handlemenu}>{t('packages')}</Link>

                                                </li>
                                                <li>
                                                    <Link to={{ pathname: `/estore`, state: { type: 'product' } }} className="main-menu-link" onClick={handlemenu}>{t('services')}</Link>

                                                </li>
                                                 <li>
                                                <Link to={{pathname: `/estore`, state: { type: 'item' }}} className="main-menu-link">Products</Link>
                                                  
                                                </li> 
                                                <li>
                                                    <Link to={{ pathname: `/estore`, state: { type: 'coupon' } }} className="main-menu-link" onClick={handlemenu}>{t('coupons')}</Link>

                                                </li>
                                            </ul> : null
                                    }

                                </li> */}

                                {/* {authUser && <li className="has-dropdown">
                                    <Link to={{ pathname: `/appointments` }} onClick={handlemenu} className="main-menu-link"><i className="fa fa-calendar-plus-o"></i>  {t('appointments')}</Link>

                                </li>} */}
                                {/* <li className='text-center'>
                                    <Link to={{ pathname: `/estore`, state: { type: 'coupon' } }} onClick={handlemenu}><img src={specialoffer} style={{ height: '35px' }} /></Link>
                                </li>
                                <li className='text-center'>
                                    <Link to={{ pathname: `/doctors` }} onClick={handlemenu} className="main-menu-link"><button className='bg-black bookbtn btn btn-sm py-1'>{t('bookappt')}</button></Link>

                                </li> */}



                            </ul>

                        </div>

                    </div>
                    <div className="mobile-contact-info">
                        {/* <div className="logo">
                            <Link to="/"><img src={logoWhite} /></Link>
                        </div>
                        <address className="address">
                           
                            <span>Call Us: +971 2 621 9996</span>
                            <span>Email: info@aecmc.com</span>
                        </address> */}
                        <ul className="social-link">
                            <li>

                                <a href="https://www.facebook.com/adamandevecosmeticmedicalcenter/" target="_blank"><IoLogoFacebook size={20} color="#ffffff" /></a>
                            </li>
                            <li>
                                <a href="https://www.twitter.com/" target="_blank"><IoLogoTwitter size={20} color="#ffffff" /></a>
                            </li>
                            {/* <li>
                            <a href="#!"><IoLogoLinkedin  size={20} color="#ffffff" /></a>
                            </li> */}
                            <li>
                                <a href="https://www.instagram.com/adamandeve_aecmc/" target="_blank"><IoLogoInstagram size={20} color="#ffffff" /></a>
                            </li>
                            <li className='mx-2'>
                                <a href="https://www.youtube.com/channel/UCjkpOCn2aIhUb6HS0msenkw" target="_blank"><IoLogoYoutube size={20} color="#ffffff" /></a>
                            </li>

                        </ul>
                        <ul className="user-link">

                            <li>
                                <select className="lang-center-input" onChange={changeLanguage} value={currentLang}>
                                    <option value="en">{t('english')}</option>
                                    <option value="ar">{t('arabic')}</option>

                                </select>

                            </li>
                            {/* 
                            {authUser && <li><a onClick={() => { signout() }}><i className="fa fa-sign-out"></i> {t('signout')}</a></li>


                            } */}

                        </ul>
                    </div>

                </div>

            </div>
            {/* <div id="offcanvas-about" className="offcanvas offcanvas-rightside offcanvas-mobile-about-section">
                <div className="offcanvas-header text-right">
                    <button className="offcanvas-close" onClick={handleabout}>
                        <img src={svg} alt="icon" />
                    </button>
                </div>
                <div className="mobile-contact-info">
                    <address className="address">
                        <img src={logoWhite} alt="logo" />
                        <span>Address: Your address goes here.</span>
                        <span>Call Us: 0123456789, 0123456789</span>
                        <span>Email: demo@example.com</span>
                    </address>
                    <ul className="social-link">
                        <li>
                            <a href="#!"><i className="fa fa-facebook"></i></a>
                        </li>
                        <li>
                            <a href="#!"><i className="fa fa-twitter"></i></a>
                        </li>
                        <li>
                            <a href="#!"><i className="fa fa-instagram"></i></a>
                        </li>
                        <li>
                            <a href="#!"><i className="fa fa-linkedin"></i></a>
                        </li>
                    </ul>
                    <ul className="user-link">
                        <li><Link to="/wishlist">Wishlist</Link></li>
                        <li><Link to="/cart">Cart</Link></li>
                        <li><Link to="/checkout-one">Checkout</Link></li>
                    </ul>
                </div>
            </div> */}

            {/* <div id="offcanvas-add-cart" className="offcanvas offcanvas-rightside offcanvas-add-cart-section">
                <div className="offcanvas-header text-right">
                    <button className="offcanvas-close" onClick={handleClick}>
                        <img src={svg} alt="icon" />
                    </button>
                </div>
                <div className="offcanvas-add-cart-wrapper">
                    <h4 className="offcanvas-title">Shopping Cart</h4>
                    <ul className="offcanvas-cart">
                        {carts?.map((data, index) => (
                            <li className="offcanvas-wishlist-item-single" key={index}>
                                <div className="offcanvas-wishlist-item-block">
                                    <Link to={`/treatments/${data.id}`} className="offcanvas-wishlist-item-image-link" >
                                        <img src={data.img} alt="img"
                                            className="offcanvas-wishlist-image" />
                                    </Link>
                                    <div className="offcanvas-wishlist-item-content">
                                        <Link to={`/treatments/${data.id}`} className="offcanvas-wishlist-item-link">{data.title}</Link>
                                        <div className="offcanvas-wishlist-item-details">
                                            <span className="offcanvas-wishlist-item-details-quantity">{data.quantity || 1} x
                                            </span>
                                            <span className="offcanvas-wishlist-item-details-price"> ${data.price}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="offcanvas-wishlist-item-delete text-right">
                                    <a href="#!" className="offcanvas-wishlist-item-delete" onClick={() => rmCartProduct(data.id)}><i className="fa fa-trash"></i></a>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className="offcanvas-cart-total-price">
                        <span className="offcanvas-cart-total-price-text">Subtotal:</span>
                        <span className="offcanvas-cart-total-price-value">${cartTotal()}.00</span>
                    </div>
                    <ul className="offcanvas-cart-action-button">
                        <li>
                            <Link to="/cartThree" className="theme-btn-one btn-black-overlay btn_md">View Cart</Link>
                        </li>
                        <li>
                            <Link to="/checkout-one" className="theme-btn-one btn-black-overlay btn_md">Checkout</Link>
                        </li>
                    </ul>
                </div>
            </div>

            <div id="offcanvas-wishlish" className="offcanvas offcanvas-rightside offcanvas-add-cart-section">
                <div className="offcanvas-header text-right">
                    <button className="offcanvas-close" onClick={handleWish}>
                        <img src={svg} alt="icon" />
                    </button>
                </div>
                <div className="offcanvas-wishlist-wrapper">
                    <h4 className="offcanvas-title">Wishlist</h4>

                    <ul className="offcanvas-wishlist">
                        {favorites?.map((data, index) => (
                            <li className="offcanvas-wishlist-item-single" key={index}>
                                <div className="offcanvas-wishlist-item-block">
                                    <Link to={`/treatments/${data.id}`} className="offcanvas-wishlist-item-image-link" >
                                        <img src={data.img} alt="img"
                                            className="offcanvas-wishlist-image" />
                                    </Link>
                                    <div className="offcanvas-wishlist-item-content">
                                        <Link to={`/treatments/${data.id}`} className="offcanvas-wishlist-item-link">{data.title}</Link>
                                        <div className="offcanvas-wishlist-item-details">
                                            <span className="offcanvas-wishlist-item-details-quantity">1 x
                                            </span>
                                            <span className="offcanvas-wishlist-item-details-price">{data.price}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="offcanvas-wishlist-item-delete text-right">
                                    <a href="#!" className="offcanvas-wishlist-item-delete" onClick={() => rmFavProduct(data.id)}><i className="fa fa-trash"></i></a>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <ul className="offcanvas-wishlist-action-button">
                        <li>
                            <Link to="/wishlist" className="theme-btn-one btn-black-overlay btn_md">View wishlist</Link>
                        </li>
                    </ul>
                </div>
            </div> */}

            <div id="search" className="search-modal">
                <button type="button" className="close" onClick={handleSearch}><img src={svg} alt="icon" /></button>
                <div className='row'>
                    <div className='col-lg-8 offset-lg-2 text-center'>
                        <input type="search" value={keyword} onChange={e => {
                            setKeyword(e.target.value)
                            props.searchTreatments(e.target.value);
                        }} placeholder={t('searchplaceholder')} />

                        {props.searched.length > 0 && keyword.length > 0 && <div className='mt-5 searchdiv'>
                            {props.searched.map((item, i) =>
                                <Link key={i} to={{
                                    pathname: `/treatments/${(item.title.en).replaceAll(' ', '-').toLowerCase()}/${i18n.language}`, state: {
                                        service: item,
                                        cartArray: myCart,
                                        count: _.countBy(myCart)[item.id]
                                    }

                                }} onClick={() => { setKeyword(""); handleSearch(); }}>
                                    <div className="row mb-4 border-bottom pb-4" >
                                        <div className='col-2'>
                                            <img className='searchedimg' src={process.env.REACT_APP_IMG_URL + item.image} />
                                        </div>
                                        <div className='col-10 text-left'>

                                            <h4 className='text-white'>{item.title[i18n.language]}</h4>
                                            <p className='font-weight-light lines p-0 mb-1'>{item.description[i18n.language]?.replace(/<[^>]+>|&nbsp;|&amp;/g, '')}</p>
                                            {/* <span className="price">

                                                                {item.type === 'package' ?

                                                                    <span className="new">{`AED ${(item.enabledGlobalDiscount) ? item.price - Math.round((item.discount / 100) * item.price) : item.price}`} {item.discount != 0 && item.enabledGlobalDiscount && <del className='price-muted font-weight-normal'> {t('aed')} {item.price} </del>} </span>

                                                                    :

                                                                    <span className="new">{`AED ${(item.price - Math.round((item.discount / 100) * item.price))}`} {item.discount != 0 && <del className='price-muted font-weight-normal'> {t('aed')} {item.price} </del>} </span>

                                                                }


                                                            </span>
                                                            {item.discount > 0 && <span className='discount badge cart-label font-weight-light ml-2'>{item.discount} % {t('discount')}</span>} */}
                                        </div>
                                    </div>
                                </Link>
                            )}
                        </div>}
                    </div>
                </div>

            </div>
        </>
    )
}

// export default Header

const mapStateToProps = state => ({
    branches: state?.branche?.branches,
    meta: state?.branche?.metaBranche,
    departments: state?.department?.departments,
    metaDepartment: state?.department?.metaDepartment,
    cart: state.user.cart,
    cartArray: state.user.cartArrays,
    servicesHeader: state?.service?.servicesHeader,
    meta: state?.service?.metaService,
    categories: state.category.categories,
    searched: state?.service?.searched,
})

const mapActionToProps = {

    fetchBranches: branche.fetchAll,
    fetchDepartments: department.fetchAll,
    updateUserCart: user.updateCart,
    fetchServices: actions.getFilteredAllServicesForHeader,
    fetchFeaturedServices: actions.getFeatured,
    searchTreatments: actions.getfiltered,
    fetchRandomPackages: actions.fetchRandomPackages,
    fetchCategories: category.fetchAll,

}

//export default withRouter (connect(mapStateToProps, mapActionToProps)(Header));
export default compose(
    withRouter,
    connect(mapStateToProps, mapActionToProps)
)(Header);